import React from 'react'

export default function SelectionButton({ cb, label, active }) {
  return (
    <div onClick={() => cb(label.toLowerCase())} className={`${active ? "bg-indigo-100 text-blue-gray-600 font-semibold" : "bg-indigo-50"} w-1/2 h-10 rounded flex items-center justify-center transition-colors cursor-pointer`}>
      <span>{label}</span>
    </div>
  )
}
